import axios from "axios";
import { environment } from "../../../environment";
const url = (externalAccountId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/external-account/v1/manual-accounts/${externalAccountId}`
        : `https://middleware.uat.farther.com/external-account/v1/manual-accounts/${externalAccountId}`;
};
export default async function updateManualAccount(clientId, externalAccountId, requestArgs, config) {
    await axios.putForm(url(externalAccountId), {
        ...requestArgs,
        data: JSON.stringify(requestArgs.data),
    }, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: "clientId" in config ? config.clientId : clientId, //Client header must always be present for this request
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
}
//# sourceMappingURL=updateManualAccount.js.map